import About from './Components/About';
import Contributors from './Components/Contributors';
import Header from './Components/Header';


function App() {
  return (
  <>
  <Header/>
   <About/>
   <Contributors/>
  </>
  );
}

export default App;